import React, {useState, useEffect,} from 'react'
import {Form, Input, Drawer, Button, Select, DatePicker} from 'antd'
import {
    I_DELIVERY_TYPE, I_ENTRUST_TYPE_YIN, I_LOGISTICS_STATUS, I_ORDER_STATUS, I_SUB_TYPE_YIT
} from "../../utills/constants";
import {convertToOptions} from "../../components/options";

const {RangePicker} = DatePicker

function SearchDrawer(props) {
    useEffect(() => {
        if (props.visible && props.searchValue) {
            props.form.setFieldsValue(props.searchValue)
        }
    }, [props.visible]);
    const handleOk = () => {
        const {validateFields} = props.form;
        validateFields((errors, values) => {
            if (errors) {
                return
            }
            props.setSearchValue(values)
            handleClose()
        })
    };
    const handleClose = () => {
        props.onClose();
    };
    const reset = () => {
        props.form.resetFields();
    }
    const listFormItemLayout = {
        labelCol: {lg: {span: 8}, md: {span: 8},},
        wrapperCol: {lg: {span: 16}, md: {span: 16},},
    }
    const {getFieldDecorator} = props.form;
    return (
        <Drawer title='筛选条件'
                width={360}
                visible={props.visible}
                onClose={handleClose}>
            <Form {...listFormItemLayout}>
                <Form.Item label="运输类型">
                    {getFieldDecorator('deliveryType',)(
                        <Select>
                            {convertToOptions(I_DELIVERY_TYPE)}
                        </Select>)}
                </Form.Item>
                <Form.Item label="委托方式">
                    {getFieldDecorator('entrustType')(
                        <Select>
                            {convertToOptions(I_ENTRUST_TYPE_YIN)}
                        </Select>)}
                </Form.Item>
                <Form.Item label="入境口岸">
                    {getFieldDecorator('customsPort')(
                        <Select>
                            {convertToOptions(props.customsPortObj)}
                        </Select>)}
                </Form.Item>
                <Form.Item label="预计抵达时间">
                    {getFieldDecorator('estimatePortDt', {})(
                        <RangePicker format="YYYY-MM-DD" style={{width: '100%'}}/>)}
                </Form.Item>
                <Form.Item label="服务类型">
                    {getFieldDecorator('subType')(
                        <Select>
                            {convertToOptions(I_SUB_TYPE_YIT)}
                        </Select>)}
                </Form.Item>
                <Form.Item label="清关/转关时间">
                    {getFieldDecorator('declaredDt', {})(
                        <RangePicker format="YYYY-MM-DD" style={{width: '100%'}}/>)}
                </Form.Item>
                <Form.Item label="集装箱号">
                    {getFieldDecorator('boxNo')(<Input/>)}
                </Form.Item>
                <Form.Item label="提单号">
                    {getFieldDecorator('ladingBillNo')(<Input/>)}
                </Form.Item>
                <Form.Item label="订单状态">
                    {getFieldDecorator('orderStatus')(
                        <Select>
                            {convertToOptions(I_ORDER_STATUS)}
                        </Select>)}
                </Form.Item>
                <Form.Item label="物流状态">
                    {getFieldDecorator('logisticsStatus')(
                        <Select>
                            {convertToOptions(I_LOGISTICS_STATUS)}
                        </Select>)}
                </Form.Item>
            </Form>
            <div
                style={{
                    position: 'absolute',
                    right: 0,
                    bottom: 0,
                    width: '100%',
                    borderTop: '1px solid #e9e9e9',
                    padding: '10px 16px',
                    background: '#fff',
                    textAlign: 'right',
                }}
            >
                <Button type="primary" style={{marginRight: 8}} onClick={handleOk}>查询</Button>
                <Button onClick={reset}>重置</Button>
            </div>
        </Drawer>
    )
}

const SearchDrawerForm = Form.create()(SearchDrawer)
export default SearchDrawerForm
